<div class="layout-footer">
    <img src="/assets/layout/images/{{layoutService.config().colorScheme === 'light' ? 'logo-dark' : 'logo-white'}}.png" alt="logo"
    height="40" class="mr-2">
</div>